import { Config, ServiceProps, ServicesMappedProps, ServicesType } from '../types';
import Button from './Button';
import { I18n } from 'i18n-js/typings/I18n';

const BoxManager = (i18n: I18n, services: ServiceProps[], config: Config) => {
  const orderedServices: ServicesMappedProps = {
    ads: [],
    mandatory: [],
    performance: [],
    features: [],
  };

  services
    .filter((service) => service.enabled)
    .forEach((service) => {
      orderedServices[service.type].push(service);
    });

  return (
    '<div class="ecodigo-ckm-box-manager">' +
    '<div class="ecodigo-ckm-box-manager__wrapper">' +
    '<button class="ecodigo-ckm-box-manager__close" title="Fermer"></button>' +
    '<div class="ecodigo-ckm-box-manager__content">' +
    '<div class="ecodigo-ckm-box-manager__inner">' +
    '<div class="ecodigo-ckm-box-manager__header">' +
    `<h2 class="ecodigo-ckm-box-manager__header__title">${i18n.t('title')}</h2>` +
    `<p class="ecodigo-ckm-box-manager__header__disclaimer">${i18n.t('disclaimer')}</p>` +
    `${
      config.policyUri
        ? `<p class="ecodigo-ckm-box-manager__header__disclaimer"><a href="${config.policyUri}" target="_blank">${i18n.t(
            'externalLinkText',
          )}</a></p>`
        : ''
    }` +
    '</div>' +
    '<div class="ecodigo-ckm-box-manager__services-list">' +
    Object.keys(orderedServices)
      .map((serviceKey) => {
        if (orderedServices[serviceKey as ServicesType]?.length === 0 && serviceKey !== 'mandatory') {
          return null;
        }

        let html = '';

        html += '<div class="ecodigo-ckm-box-manager__services-list__item">';
        html += ' <div class="ecodigo-ckm-box-manager__services-list__item__header">';
        html += '   <h3 class="ecodigo-ckm-box-manager__services-list__item__header__title">';
        html += `     ${i18n.t(`services.${serviceKey}.title`)}`;
        html += '   </h3>';
        html += '   <div class="ecodigo-ckm-box-manager__services-list__item__header__features">';
        html += '       <div class="ecodigo-ckm-box-manager__services-list__item__header__switch ecodigo-ckm-switch">';
        if (serviceKey !== 'mandatory') {
          html += `            <input class="ecodigo-ckm-switch__input" role="switch" type="checkbox" value="1" data-service="${serviceKey}" />`;
        } else {
          html += `            <input class="ecodigo-ckm-switch__input" role="switch" type="checkbox" value="1" data-service="${serviceKey}" checked disabled />`;
        }
        html += '       </div>';
        html += '       <div class="ecodigo-ckm-box-manager__services-list__item__header__arrow"></div>';
        html += '   </div>';
        html += ' </div>';
        html += ' <div class="ecodigo-ckm-box-manager__services-list__item__content">';
        html += '   <p class="ecodigo-ckm-box-manager__services-list__item__content__details">';
        html += `     ${i18n.t(`services.${serviceKey}.details`)}`;
        html += '   </p>';
        html += ' </div>';
        html += '</div>';

        return html;
      })
      .join('') +
    '</div>' +
    '<div class="ecodigo-ckm-box-manager__buttons">' +
    Button({
      className: 'ecodigo-ckm-box-manager__buttons__button btn btn-lg btn-outline-blue',
      content: i18n.t('allowAll'),
      dataAction: 'allowAll',
    }) +
    Button({
      className: 'ecodigo-ckm-box-manager__buttons__button btn btn-lg btn-blue',
      content: i18n.t('confirm'),
      dataAction: 'confirm',
    }) +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>'
  );
};

export default BoxManager;
